import { ITerminologyItem } from "./tokenize-string";

export const formatCountTerminology = (count: number, terminology: ITerminologyItem) => {
  if (count === 1) {
    return `${count} ${terminology.singular.text}`;
  } else {
    return `${count} ${terminology.plural.text}`;
  }
};
